module.exports = __webpack_public_path__ + "img/hg-idb.303cc17c.svg";